import { createI18n } from 'vue-i18n';
import es from './es.json';
import en from './en.json';
import de from './de.json';

export const SUPPORTED_LOCALES = ['es', 'en', 'de'] as const;
export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

const LOCALE_STORAGE_KEY = 'app-myticket:locale';

function isSupported(value: string | undefined | null): value is AppLocale {
  return !!value && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

export function detectInitialLocale(): AppLocale {
  const stored = typeof localStorage !== 'undefined' ? localStorage.getItem(LOCALE_STORAGE_KEY) : null;
  if (isSupported(stored)) return stored;

  const envDefault = import.meta.env.VITE_DEFAULT_LOCALE;
  if (isSupported(envDefault)) return envDefault;

  if (typeof navigator !== 'undefined' && navigator.language) {
    const short = navigator.language.slice(0, 2).toLowerCase();
    if (isSupported(short)) return short;
  }

  return 'es';
}

export const i18n = createI18n({
  legacy: false,
  locale: detectInitialLocale(),
  fallbackLocale: 'en',
  globalInjection: true,
  messages: { es, en, de },
});

export function setLocale(locale: AppLocale) {
  i18n.global.locale.value = locale;
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  }
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale;
  }
}

export function getCurrentLocale(): AppLocale {
  return i18n.global.locale.value as AppLocale;
}
